export const getBaseURL = (url: string) => {
  const urlParts = url.split('?');

  if (urlParts.length > 0) {
    return urlParts[0];
  }
  return url;
};

export const getParamsFromUrl = (url: string) => {
  const urlParts = url.split('?');
  const allParameters: Record<string, string> = {};

  if (urlParts.length > 1) {
    const parameters = urlParts[1].split('&');

    for (const parameter of parameters) {
      const parameterParts = parameter.split('=');

      if (parameterParts.length > 1) {
        allParameters[parameterParts[0]] = parameterParts[1];
      } else if (parameterParts.length > 0) {
        allParameters[parameterParts[0]] = '';
      }
    }
  }
  return allParameters;
};

export const attachParams = (url: string, adsParameters: Record<string, string>) => {
  let finalURL = url;
  let seperator = url.includes('?') ? '&' : '?';

  for (const parameter in adsParameters) {
    finalURL += `${seperator}${parameter}=${adsParameters[parameter]}`;
    seperator = '&';
  }

  return finalURL;
};
